import { normalizeLoadingPhaseText } from "./loadingPhaseCatalog";
import { processNodePreviewText } from "./loadingPhaseProcessModel";

const PROCESS_SIDE_BY_STAGE = {
  market_indices: -1,
  criteria: -1,
  time_scales: 1,
  quotes: 1,
  stats: -1,
  short_setup: -1,
  filings: 1,
  evidence: 1,
  direct_data: 1,
  macro: -1,
  news: 1,
  chart_context: 1,
  plan: 1,
  specialists: 1,
  synthesis: 1,
  deep_thinking: -1,
  response: 1,
};

const UNSAFE_PHASE_DETAIL_PATTERN = /\b(?:directive|schema|json|prompt|system message|developer message|instruction|guidelines?|rubric|expected action|score table|output format|formatting requirements?|internal|mechanics|must include|must always|platform expects|requires scoring)\b/i;

export const sideForNode = (node, index) => {
  const normalized = normalizeLoadingPhaseText(node?.rawLabel || node?.label || "");
  if (normalized.startsWith("engaging agentic advanced filtering")) return 1;
  return PROCESS_SIDE_BY_STAGE[node?.stageKey] || (index % 2 === 0 ? -1 : 1);
};

export const publicPhaseDetailText = (value) => {
  const text = String(value || "").trim();
  if (!text || UNSAFE_PHASE_DETAIL_PATTERN.test(text)) return "";
  return text;
};

export const nodeCardWidthFor = (node, compactDesktop = false) => {
  const previewLines = processNodePreviewText(node).split("\n").filter(Boolean);
  const longestLineLength = [node?.label, ...previewLines]
    .map((line) => String(line || "").length)
    .reduce((max, length) => Math.max(max, length), 0);
  const minWidth = compactDesktop ? 174 : 184;
  const maxWidth = compactDesktop ? 224 : 238;
  const estimatedWidth = Math.round(58 + Math.min(longestLineLength, 36) * (compactDesktop ? 5.1 : 5.35));

  return Math.max(minWidth, Math.min(maxWidth, estimatedWidth));
};
